// utils/walletUtils.js
import Wallet from 'sats-connect';
import { AddressPurpose } from 'sats-connect';

export const connectWallet = async (setConnected, setsortAddress) => {
  const response = await Wallet.request('getAccounts', {
    purposes: [AddressPurpose.Payment, AddressPurpose.Ordinals],
    message: 'We need your BTC addresses!',
    network: { type: process.env.REACT_APP_BTCNETWORK },
  });
  const accounts = response;
  if (accounts.result) {
    window.localStorage.setItem('walletStatus', true);
    window.localStorage.setItem('paymentAddress', accounts.result[0].address);
    window.localStorage.setItem('ordinalAddress', accounts.result[1].address);
    window.localStorage.setItem('paymentPubKey', accounts.result[0].publicKey);
    window.localStorage.setItem('ordinalPubKey', accounts.result[1].publicKey);
    setConnected(true);
    const truncatedText = truncateString(accounts.result[1].address);
    setsortAddress(truncatedText);
  } else {
    setConnected(false);
  }
};

export const disconnectWallet = async (setConnected, setShowDisconnect) => {
  await Wallet.disconnect();
  window.localStorage.removeItem('walletStatus');
  window.localStorage.removeItem('ordinalAddress');
  window.localStorage.removeItem('paymentAddress');
  window.localStorage.removeItem('paymentPubKey');
  window.localStorage.removeItem('ordinalPubKey');
  window.localStorage.removeItem('selectedUsername');
  setConnected(false);
  setShowDisconnect(false);
};

export const truncateString = (str) => {
  const prefixLength = 4;
  const suffixLength = 4;
  const ellipsis = '...';
  if (str) {
    if (str.length <= prefixLength + suffixLength) {
      return str;
    }
    const start = str.slice(0, prefixLength);
    const end = str.slice(-suffixLength);
    return `${start}${ellipsis}${end}`;
  }
};

export const handleClickOutside = (event, disconnectRef, setShowDisconnect) => {
  if (disconnectRef.current && !disconnectRef.current.contains(event.target)) {
    setShowDisconnect(false);
  }
};

export const showDisconnectBtn = (event, setShowDisconnect) => {
  event.preventDefault();
  setShowDisconnect((prev) => !prev);
};

export const handleDisconnect = (event, setConnected, setShowDisconnect) => {
  event.stopPropagation();
  disconnectWallet(setConnected, setShowDisconnect);
  setShowDisconnect(false);
};
